import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILink from 'UIComponents/link/UILink';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';

const QuizError = ({
  progressToNextContent
}) => /*#__PURE__*/_jsx("div", {
  className: "quiz-error",
  "data-test-id": "quiz-error-wrapper",
  children: /*#__PURE__*/_jsxs(UIErrorMessage, {
    className: "quiz-error__content",
    type: "badRequest",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.quiz.genericError"
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: progressToNextContent,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.quiz.skipQuiz"
      })
    })]
  })
});

export default QuizError;